import { Model } from '@vuex-orm/core';

export default class TechnischeInfrastruktur extends Model {
  static entity = 'technischeInfrastruktur';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.id;
    /** @type {string} */
    this.name;
  }

  static fields() {
    return {
      id: this.string(''),
      name: this.string('')
    };
  }
}
